<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Charte et envoi de ma demande d'agrément">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-row v-if="!isDossierComplet">
          <v-col>
            <p class="text-sm-left body-3 font-weight-bold">
              Vous devez remplir l'ensemble du formulaire afin de valider votre
              demande d'agrément.
            </p>
          </v-col>
        </v-row>
        <v-form v-else ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <p class="text-sm-left body-3 font-weight-bold">
                Charte d'engagement du pharmacien maître de stage
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <p class=" body-3 text-justify">
                Les pharmaciens maîtres de stage agréés s’engagent à respecter
                les points suivants qui constituent la charte d’engagement du
                maître de stage telle qu’elle est exprimée dans l’arrêté du 17
                juillet 1987, modifiée par l’arrêté du 14 août 2003 – article 24
                :
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <p class="text-justify body-3 margin-left">
                - avoir une disponibilité suffisante pour consacrer le temps
                nécessaire à la formation pratique du stagiaire ;
              </p>
              <p class="text-justify body-3 margin-left">
                - inspirer au stagiaire le respect de la profession de
                pharmacien d’officine et lui donner l’exemple des qualités
                professionnelles requises, en particulier le respect de la
                législation, de la réglementation et de la déontologie ;
              </p>
              <p class="text-justify body-3 margin-left">
                - assister obligatoirement aux formations des maîtres de stage
                organisées par la Faculté ;
              </p>
              <p class="text-justify body-3 margin-left">
                - suivre l’évolution du métier de pharmacien d’officine et
                participer aux formations concourant à la mise à jour des
                connaissances nécessaires à l’exercice du métier de pharmacien
                d’officine ; notamment aux EPU organisés par la faculté de
                Pharmacie ;
              </p>
              <p class="text-justify body-3 margin-left">
                - faire participer à la formation du stagiaire une équipe
                officinale qualifiée ;
              </p>
              <p class="text-justify body-3 margin-left">
                - associer le stagiaire au suivi thérapeutique des patients, à
                la pratique de l’opinion pharmaceutique et aux entretiens
                pharmaceutiques, en lui faisant prendre conscience de son rôle
                d’acteur de santé publique ;
              </p>
              <p class="text-justify body-3 margin-left">
                - communiquer au stagiaire son expérience professionnelle, y
                compris les bases élémentaires de gestion d’une officine, et des
                relations humaines ;
              </p>
              <p class="text-justify body-3 margin-left">
                - faciliter la participation du stagiaire aux réunions
                d’information et de formation se déroulant au cours du stage ;
              </p>
              <p class="text-justify body-3 margin-left">
                - accepter l’évaluation du déroulement du stage et de la
                formation reçue par le stagiaire ;
              </p>
              <p class="text-justify body-3 margin-left">
                - accueillir et encadrer les étudiants quel que soit leur niveau
                d’étude ;
              </p>
              <p class="text-justify body-3 margin-left">
                - appliquer strictement le barème d’indemnisation des étudiants
                en pharmacie en stage de 6ème année ;
              </p>
              <p class="text-justify body-3 margin-left">
                - participer aux jurys de validation de stage ;
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <p class="text-left body-3 font-weight-bold">
                Cette charte vous engage. Son non-respect pourrait entraîner la
                suppression de l’agrément
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-checkbox
                v-model="dossier.charte"
                label="En cochant cette case, je reconnais avoir lu la charte d’engagement des pharmaciens maitres de stage
et je m’engage à la respecter."
                class="pa-1 mt-0"
                hide-details
                :rules="checkboxRules"
                :error="!charteCochee"
              >
              </v-checkbox>
              <v-row>
                <v-col cols="7">
                  <v-text-field
                    v-model="dossier.signatureNom"
                    label="Votre nom :"
                    required
                    :rules="textRules"
                  />
                </v-col>
                <v-col cols="5"> </v-col>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <v-text-field
                    v-model="dossier.signatureDate"
                    label="Demande effectuée en date du : "
                    required
                    :rules="textRules"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <v-btn
                :href="linkToPDF(dossier)"
                color="grey"
                class="mr-4 white--text"
                download
              >
                <v-icon>file_download</v-icon> Voir le récupitulatif de ma
                demande**
              </v-btn>
              <p class="text-sm-left body-3 font-italic">
                ** prenez le temps de vérifier la conformité des informations
                saisies<br />avant la validation et la transmission de votre
                demande
              </p></v-col
            >
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Valider et transmettre ma demande d'agrément
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import common from "@/common";
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Partie18",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    menu: false,
    textRules: [v => !!v || "Ce champ est requis"],
    checkboxRules: [v => v !== null || "Ce champ est requis"]
  }),
  computed: {
    charteCochee() {
      return this.dossier.charte;
    },
    isDossierComplet() {
      return JSON.parse(this.dossier.parties).length >= 17;
    }
  },
  created() {
    if (this.dossier.dateFormationEtp) {
      let unix_timestamp = this.dossier.dateFormationEtp;
      var date = new Date(unix_timestamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.dateFormationEtp = year + "-" + month + "-" + day;
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        if (!this.dossier.charte) {
          this.$toast.erreur("Vous devez accepter la charte.");
        } else {
          if (JSON.parse(this.dossier.parties).length >= 17) {
            this.dossier.etat.id = 2;
          }
          this.$emit("save");
        }
      }
    },
    linkToPDF(dossier) {
      return common.getPDFURL(dossier, dossier.codeAcces);
    }
  }
};
</script>
<style>
.p-dateNaissance {
  padding-top: 0;
  margin-top: -25px;
}
.margin-left {
  margin-left: 30px;
}
</style>
